module.exports = "<div class=\"row\">\n  <div class=\"col-16\">\n    <ul class=\"list-inline mb-0\">\n      <li class=\"list-inline-item edit-rootftop-btn-p\">\n        <button class=\"btn btn-secondary edit-rootftop-btn\" type=\"button\">Copy Rooftop</button>\n      </li>\n      <li class=\"list-inline-item\">\n        <button class=\"btn btn-secondary edit-rootftop-btn\" type=\"button\">Remove Rooftop</button>\n      </li>\n    </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dealer/edit-rootftop/index.html
// module id = ./src/app/components/dealer/edit-rootftop/index.html
// module chunks = main